import { Injectable } from '@angular/core';

import { SecurityService } from '../services/security.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(private securityService: SecurityService) {}

  async canActivate(): Promise<boolean> {
    if (this.securityService.accountIsVerified) {
      return true;
    }

    await this.securityService.startAuthentication();
    return false;
  }
}
